(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductCard extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('.product-card__link');
      if (!link) return;
      
      this.addEventListener('click', (e) => {
        if (e.target.closest('button, input, select, [data-no-redirect]')) return;
        window.location.href = link.href;
      });
    }
  }
  
  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
  }
  } catch(e) { console.error(e); }
})();

})();
